import React, { useState } from 'react'

import { Input, Button, ImageUpload, ConfirmModal, EditorTransitionPrompt, TextArea, Select } from '../../components'
import { DeleteIcon, SortUp, SortDown } from '../icons'
import useModel from '../../common/useModel'
import required from '../../common/validators/required'

import S from './styled'
const imageUloadStyle = { marginTop: '10px' }

const Item = ({
  item, locales, onDelete, noDescription, onSave, onCancelNew, isNew, withImage, textArea, imageRequired, noStretch,
  hasType, types,
  additionalEntities,
  additionalField: AdditionalField,
}) => {

  const ItemModel = useModel({
    values: item,
  })

  const { text, reset, model, image, select, resetDirty, values } = ItemModel

  const [showModal, setShowModal] = useState(false)

  const [collapsed, setCollapsed] = useState(!isNew)

  const defaultLocale = (locales[0] || { id: 0 }).id

  const InputComponent = textArea ? TextArea : Input

  if (collapsed) {
    return (
      <S.Item>
        <S.ItemContent onClick={() => setCollapsed(false)} className="collapsed">
          {
            isNew ? <S.IconPlaceholder /> : (
              <S.DeleteLink onClick={
                e => {
                  setShowModal(true)
                  e.stopPropagation()
                }
              } className="collapsed">
                <DeleteIcon />
              </S.DeleteLink>
            )
          }
          <S.Title>
            {
              withImage && <img src={values.image} alt=""></img>
            }
            {
              !noDescription && values.description
            }
            {
              noDescription && values.translates[Reflect.ownKeys(values.translates)[0]]
            }
          </S.Title>
          <S.Collapse>
            <SortUp />
          </S.Collapse>
        </S.ItemContent>
        <ConfirmModal
          isOpened={showModal}
          onClose={() => setShowModal(null)}
          onConfirm={() => {
            setShowModal(null)
            onDelete(item.id, item)
          }}
          redConfirm
        >
          Are you sure you want to delete this item?
        </ConfirmModal>
      </S.Item>
    )
  }

  return (
    <S.Item>
      <EditorTransitionPrompt when={model.isDirty}/>
      <S.ItemContent>
        {
          isNew ? <S.IconPlaceholder /> : (
            <S.DeleteLink onClick={
              () => setShowModal(true)
            }>
              <DeleteIcon />
            </S.DeleteLink>
          )
        }

        <div>
          {!noDescription && (
            <Input {...{
              name: 'values.description',
              text,
              title: 'Description',
              validate: required,
              autoFocus: isNew,
              tabIndex: 1,
            }}
            />
          )}
          {hasType && (
            <Select {...{
              name: 'values.typeId',
              select,
              title: 'Type',
              values: types,
              validate: required,
              tabIndex: -1,
            }}
            />
          )}
          {
            AdditionalField && <AdditionalField {...{
              model: ItemModel, additionalEntities, types, defaultLocale,
            }}/>
          }
          { withImage && <ImageUpload {...image({
            name: 'values.image',
            ...( imageRequired ? { validate: required } : null),
          })} style={imageUloadStyle} noStretch={noStretch}/>}
        </div>

        <S.Locales>
          {
            locales.map((locale, index) => (
              <div key={`locale_${index}`}>
                <InputComponent {...{
                  name: `values.translates.${locale.id}`,
                  text,
                  title: locale.name,
                  warnEmpty: true,
                  validate: locale.id === defaultLocale ? required : null,
                  rows: 5,
                  tabIndex: index + 2,
                }}
                />
              </div>
            ))
          }
        </S.Locales>
        {
          !isNew && (
            <S.Collapse onClick={() => setCollapsed(true)} className="collapseUp">
              <SortDown />
            </S.Collapse>
          )
        }
      </S.ItemContent>
      <S.ItemFooter>
        { isNew && (<Button blue outlined onClick={() => onCancelNew()}>Cancel</Button>) }
        { !isNew && model.isDirty && (<Button blue outlined onClick={() => reset('values')}>Reset</Button>) }
        <Button
          blue disabled={!model.isDirty || !model.isValid}
          onClick={() => onSave(model.values).then(resetDirty)}>
          {isNew ? 'Add' : 'Save'}
        </Button>
      </S.ItemFooter>
      <ConfirmModal
        isOpened={showModal}
        onClose={() => setShowModal(null)}
        onConfirm={() => {
          setShowModal(null)
          onDelete(item.id, item)
        }}
        redConfirm
      >
        Are you sure you want to delete this item?
      </ConfirmModal>
    </S.Item>
  )
}

export default Item
